import React from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/global.css";

type BaseButtonProp = {
  text: string;
  name?: string;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  processing?: boolean;
  variant?: string;
  styles?: string;
  click?: () => void;
  to?: string;
  hasLeftIcon?: boolean;
  hasRightIcon?: boolean;
  children?: any;
  hasWhatAppIcon?: boolean;
};

const BaseButton: React.FC<BaseButtonProp> = ({
  text,
  name,
  type,
  disabled = false,
  processing = false,
  variant,
  styles = "",
  click,
  to,
  hasLeftIcon = false,
  hasRightIcon = false,
  children,
  hasWhatAppIcon = false,
}) => {
  const navigate = useNavigate();
  const handleClick = () => {
    if (to) {
      navigate(to);
    }
  };
  return (
    <>
      <button
        name={name}
        aria-label={text}
        type={type || "button"}
        className={`${styles} btn cursor-pointer  centered_row outline-none focus:outline-none text-white h-12 rounded-full transition active:bg-[#ffffff33] ${
          variant === "primary"
            ? `bg-[#3A966C] text-white hover:bg-[#032c36]`
            : `bg-transparent border border-green-800 textbrandColor hover:font-medium hover:border-2`
        } ${
          disabled || processing ? "disabled:bg-[#3A966C]/[0.4]" : ""
        } lg:text-md md:text-[13px] text-[14px]`}
        disabled={disabled || processing}
        onClick={to ? handleClick : click}
      >
        {hasLeftIcon && <>{children}</>}
        {!processing ? text : "Please wait..."}
        {hasRightIcon && <>{children}</>}
        {hasWhatAppIcon && <>{children}</>}
      </button>
    </>
  );
};

export default BaseButton;
